import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Element from 'element-ui'
require('js-base64').Base64;
// Base64.encode 加密
// Base64.decode 解密
import 'element-ui/lib/theme-chalk/index.css';
import 'lib-flexible'
import './index.scss'
Vue.config.productionTip = false
Vue.use(Element)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
